import React from 'react';

const RankinIcon = ({ className, style }) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    className,
    style: { ...style, overflow: "visible" },
    width: "28",
    height: "29",
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M7.78159 17.2446H4.66659C3.38325 17.2446 2.33325 18.2946 2.33325 19.578V25.4113C2.33325 26.053 2.85825 26.578 3.49992 26.578H7.78159C8.42325 26.578 8.94825 26.053 8.94825 25.4113V18.4113C8.94825 17.7696 8.42325 17.2446 7.78159 17.2446Z",
      fill: "#008500"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M15.5516 12.5776H12.4366C11.1533 12.5776 10.1033 13.6276 10.1033 14.911V25.411C10.1033 26.0526 10.6283 26.5776 11.2699 26.5776H16.7183C17.3599 26.5776 17.8849 26.0526 17.8849 25.411V14.911C17.8849 13.6276 16.8466 12.5776 15.5516 12.5776Z",
      fill: "#008500"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M23.3334 20.7446H20.2184C19.5768 20.7446 19.0518 21.2696 19.0518 21.9113V25.4113C19.0518 26.053 19.5768 26.578 20.2184 26.578H24.5001C25.1418 26.578 25.6668 26.053 25.6668 25.4113V23.078C25.6668 21.7946 24.6168 20.7446 23.3334 20.7446Z",
      fill: "#008500"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M17.5118 6.56936C17.8734 6.2077 18.0134 5.77603 17.8968 5.4027C17.7801 5.02936 17.4184 4.76103 16.9051 4.67936L15.7851 4.4927C15.7384 4.4927 15.6334 4.41103 15.6101 4.36436L14.9918 3.1277C14.5251 2.1827 13.4634 2.1827 12.9968 3.1277L12.3784 4.36436C12.3668 4.41103 12.2618 4.4927 12.2151 4.4927L11.0951 4.67936C10.5818 4.76103 10.2318 5.02936 10.1034 5.4027C9.98676 5.77603 10.1268 6.2077 10.4884 6.56936L11.3518 7.44436C11.3984 7.47936 11.4334 7.61936 11.4218 7.66603L11.1768 8.73936C10.9901 9.54436 11.2934 9.90603 11.4918 10.046C11.6901 10.186 12.1218 10.3727 12.8334 9.9527L13.8834 9.33436C13.9301 9.29936 14.0818 9.29936 14.1284 9.33436L15.1668 9.9527C15.4934 10.151 15.7618 10.2094 15.9718 10.2094C16.2168 10.2094 16.3918 10.116 16.4968 10.046C16.6951 9.90603 16.9984 9.54436 16.8118 8.73936L16.5668 7.66603C16.5551 7.6077 16.5901 7.47936 16.6368 7.44436L17.5118 6.56936Z",
      fill: "#008500"
    }
  )
);
RankinIcon.displayName = "Icons.RankinIcon";

export { RankinIcon };
//# sourceMappingURL=RankinIcon.js.map
